import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { authSetAuthenticated } from '@unified-ui/shared/auth-lib';
import { catchError, map, of, switchMap } from 'rxjs';
import { EntitlementsApiService } from '../services/entitlements-api.service';
import { getUserEntitlementsError, setUserEntitlements } from './entitlements.actions';

@Injectable()
export class EntitlementsEffects {
    private actions$ = inject(Actions);
    private _entitlementsApiService = inject(EntitlementsApiService);


    /**
     * Get user entitlements
     * */
    public getUserEntitlements$ = createEffect(() =>
        this.actions$.pipe(
            ofType(authSetAuthenticated),
            switchMap(authenticated => {
                if (!authenticated) {
                    return of();
                }
                return this._entitlementsApiService.getUserEntitlements().pipe(
                    map(data => {
                        return setUserEntitlements(data.data);
                    }),
                    catchError(() => of(getUserEntitlementsError()))
                );
            })
        )
    );
}
